var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.973,
    height: 23.972
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.072 23.387L.587 14.901a2 2 0 010-2.829 2 2 0 012.828 0l5.073 5.071V1.999a2 2 0 012-2 2 2 0 012 2v15.144l5.069-5.07a2 2 0 012.829 0 2 2 0 010 2.829l-8.482 8.486a2 2 0 01-1.416.585 2 2 0 01-1.416-.586z",
    fill: "#78d887"
  })));
}
export default SvgDownloadIcon;